import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import { environment } from '@Env/environment';
import { getParams } from '@Services/common/services-utils';
import { Site } from './site.model';


@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private url = `${environment.baseUrl}/api_bdc/sites/`;
  private url_pages = `${environment.baseUrl}/api_bdc/pages/`;

  constructor(private http: HttpClient) {}

  get(id: number) {
    return this.http.get<Site>(`${this.url}${id}`);
  }

  list(
    offset: number = 0,
    limit: number = 0,
    keyword: string = window.location.hostname,
  ) {
    const params = getParams(limit, offset, keyword);
    return this.http.get<Site[]>(this.url, {params});
  }

  update(site: Site) {
    return this.http.put<Site>(`${this.url}${site.id}/`, site);
  }

  create(site: Site) {
    return this.http.post<Site>(this.url, site);
  }

  updateOrCreate(site: Site) {
    return ('id' in site) ? this.update(site) : this.create(site);
  }

  delete(site: Site) {
    return this.http.delete<Site>(`${this.url}${site.id}/`);
  }
}
